



















































































































































































































































































































































import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'
import qs from 'qs'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { ViewType } from '~/models/shared/types'
import { USER_NS } from '~/store/modules/shared/user/state'
import { Classified } from '~/models/classified/types'
import { SET_PAGE } from '~/store/modules/shared/classifieds/search/mutation-types'
import Pagination from '~/components/car/classifieds/search/results/Pagination.vue'
import SortOptions from '~/components/car/classifieds/search/results/header/SortOptions.vue'
import SaveSearchButton from '~/components/car/classifieds/search/results/header/SaveSearchButton.vue'
import ShareButton from '~/components/car/classifieds/search/results/header/ShareButton.vue'
import ClearAllButton from '~/components/car/classifieds/search/facets/ClearAllButton.vue'
import ViewTypeSelector from '~/components/car/classifieds/search/results/header/ViewTypeSelector.vue'
import CGoogleAd from '~/components/shared/configurable/ad/CGoogleAd.vue'
import CAdmanAd from '~/components/shared/configurable/ad/CAdmanAd.vue'
import GalleryRow from '~/components/car/classifieds/search/results/rows/main/GalleryRow.vue'
import ListRow from '~/components/car/classifieds/search/results/rows/main/ListRow.vue'
import {
  faCaretDown,
  faExclamationCircle
} from '@fortawesome/free-solid-svg-icons'
import SortOptionsModal from '~/components/car/classifieds/search/results/header/SortOptionsModal.vue'
import MobileTopBarShareButton from '~/components/car/classifieds/search/mobile/MobileTopBarShareButton.vue'
import RowAd from '~/components/car/classifieds/search/results/RowAd.vue'
import { paramsValuesAsArrays, preprocessParams } from '~/utils/http'
import { ADS_NS } from '~/store/modules/shared/ads/state'
import { formatNumber } from '~/utils/number'
import { toCamelCase } from '~/utils/object'
import { mapDeps } from '~/plugins/dependency-container/utils'
import ClassifiedSearchActionsService from '~/services/search/ClassifiedSearchActionsService'
import { APP_NS } from '~/store/modules/shared/app/state'
import CAgentProfile from '~/components/shared/configurable/CAgentProfile.vue'
import {
  useMapSearchBottomAds,
  useSearchBottomAds,
  useSearchRowsAds
} from '~/compositions/ad'
import { defineComponent } from '@nuxtjs/composition-api'
import RowsContainer from '~/components/car/classifieds/search/results/rows/main/RowsContainer.vue'
import SearchService from '~/services/search/SearchService'
import { CategoryId } from '~/models/category/types'
import CFacetButton from '~/components/shared/configurable/button/CFacetButton.vue'
import SelectedHandlers from '~/components/car/classifieds/search/results/header/SelectedHandlers.vue'
import CPagination from '~/components/shared/configurable/pagination/CPagination.vue'
import NoResultsFound from '~/components/car/classifieds/search/results/rows/NoResultsFound.vue'
import { defineVue3AsyncComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CPagination,
    ViewTypeSelector,
    Pagination,
    SortOptions,
    SaveSearchButton,
    ShareButton,
    GalleryRow,
    ListRow,
    NoResultsFound,
    ClearAllButton,
    CGoogleAd,
    CAdmanAd,
    SortOptionsModal,
    MobileTopBarShareButton,
    RowAd,
    SelectedHandlers,
    CAgentProfile,
    SellerRow: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/search/results/rows/main/SellerRow.vue'
      )
    ),
    RowsContainer,
    CExpandableContent: defineVue3AsyncComponent(() =>
      import('~/components/shared/configurable/expand/CExpandableContent.vue')
    ),
    CFacetButton
  },
  props: {
    mobile: { type: Boolean, default: false },
    columns: { type: Number, default: 2 },
    loading: { type: Boolean, default: false },
    loadingFacets: { type: Boolean, default: false },
    // Display rows in modal when the cluster has multiple classifieds
    displayClusterRows: { type: Boolean, default: false },
    csp: { type: Number, default: null },
    compareCountVisible: { type: Boolean, default: false },
    frozenList: { type: Boolean, default: false },
    wihtoutAds: { type: Boolean, default: false }
  },
  setup() {
    const { rowsAds, sellersAds } = useSearchRowsAds()
    const { fullAd: mapBottomFullAd } = useMapSearchBottomAds()
    const { fullAd: mobileBottomFullAd, leftAd, rightAd } = useSearchBottomAds()

    return {
      rowsAds,
      sellersAds,
      mapBottomFullAd,
      mobileBottomFullAd,
      leftAd,
      rightAd
    }
  },
  data() {
    return {
      hoverClassifiedId: null,
      icons: {
        sort: faCaretDown,
        exclamation: faExclamationCircle
      },
      currentClusterPage: 1,
      freezeButtonShown: true,
      isExpandableMounted: false,
      isAgentProfileFullSize: true
    }
  },
  computed: {
    ...mapDeps({
      classifiedSearchActionsService: ClassifiedSearchActionsService
    }),
    ...mapState(USER_NS, {
      user: state => state
    }),
    ...mapGetters(APP_NS, {
      isCar: 'isCar',
      isPlot: 'isPlot'
    }),
    ...mapState(CLASSIFIED_SEARCH_NS, {
      newWantedClassifiedUrl: state => state.newWantedClassifiedUrl,
      rows: state => state.rows,
      userProfile: state => state.userProfile,
      clusterRows: state => state.clusterRows,
      currentPage: state => state.pagination.page,
      rowsTotalClassifieds: state => state.pagination.total,
      clusterRowsPagination: state => state.clusterPagination,
      rowsPagination: state => state.pagination,
      loadingClusterResults: state => state.loading.clusterResults,
      categoryName: state => state.category.humanName,
      viewType: state => state.viewType,
      rootParams: state => state.config.rootParams,
      config: state => state.config,
      params: state => state.params,
      sellerRows: state => state.sellerRows,
      isMapSearch: state => state.flags.isMapSearch,
      categoryIds: state => state.categoryIds,
      mapSearchUrl: state => state.mapSearchUrl
    }),
    ...mapGetters(CLASSIFIED_SEARCH_NS, {
      adsKeyValues: 'getAdsKeyValues',
      viewTypeIsList: 'viewTypeIsList',
      selectedHandlers: 'getSelectedFacets',
      shouldDisplayAds: 'shouldDisplayAds',
      showSellers: 'showSellers',
      getFacetByName: 'getFacetByName',
      facetCount: 'getFacetsCount'
    }),
    ...mapState(ADS_NS, {
      showAdmanAds: state => state.showAdmanAds
    }),
    resultsLabel() {
      if (
        this.showSellers &&
        [CategoryId.VEHICLES, CategoryId.PARTS].some(c =>
          this.categoryIds.includes(c)
        )
      ) {
        return this.$i18n.t('dealers')
      } else if (
        this.showSellers &&
        this.categoryIds.includes(CategoryId.XYMA)
      ) {
        return this.$i18n.t('sellers')
      }
      if (this.showSellers && this.isMapSearch) {
        return this.$i18n.t('agents::plural')
      } else {
        return this.$i18n.t('classifieds')
      }
    },
    viewTypeIsGallery(): boolean {
      return this.viewType === ViewType.GALLERY
    },
    rowComponent() {
      return this.viewTypeIsGallery ? GalleryRow : ListRow
    },
    rowItemClass(): string {
      if (this.viewType === ViewType.GALLERY && this.mobile) {
        return `r-col-1`
      } else if (this.viewType === ViewType.GALLERY && !this.mobile) {
        return `r-col-${this.columns}`
      } else if (this.viewType === ViewType.LIST && !this.mobile) {
        return 'desktop-list'
      } else {
        return this.viewType
      }
    },
    isPc() {
      return !this.mobile
    },
    shareTitle() {
      return this.$t('i found these interesting results in {site}', {
        site: this.siteDomain
      })
    },
    siteDomain() {
      return process.env.DOMAIN || 'car.gr'
    },
    classifiedRows(): [] {
      if (this.displayClusterRows) {
        return this.clusterRows
      } else {
        return this.rows
      }
    },
    totalClassifieds(): number {
      if (this.displayClusterRows) {
        return formatNumber(this.clusterRowsPagination.total)
      } else {
        return formatNumber(this.rowsTotalClassifieds)
      }
    },
    numberOfPages(): number {
      let pagination = null
      if (this.displayClusterRows) {
        pagination = this.clusterRowsPagination
      } else {
        pagination = this.rowsPagination
      }
      if (pagination?.total) {
        return Math.ceil(pagination.total / pagination.perPage)
      }
      return 0
    },
    freezeListButtonTitle() {
      return this.frozenList
        ? this.$i18n.t('unfreeze list')
        : this.$i18n.t('freeze list')
    },
    freezeTooltipTitle() {
      return this.frozenList
        ? this.$i18n.t(
            'by clicking {unfreezelist} you activate the auto update in search results from the map.',
            { unfreezelist: `"${this.$i18n.t('unfreeze list')}"` }
          )
        : this.$i18n.t(
            'by clicking {freezelist} you deactivate the auto update in search results from the map.',
            { freezelist: `"${this.$i18n.t('freeze list')}"` }
          )
    },
    selectedHandlersCount() {
      if (this.selectedHandlers?.length) {
        return this.selectedHandlers.length
      }
      return 0
    },
    handlersParamsValues() {
      let paramNames = []
      this.selectedHandlers.forEach(handler => {
        paramNames = handler.values.humanParams.map(h => h.name)
      })
      return paramNames.join(',')
    },
    withoutMapUrl() {
      if (!this.mapSearchUrl) {
        return null
      }

      const [categoryUlr, queryParamsString] = this.mapSearchUrl.split('?')
      const qParams = qs.parse(queryParamsString)
      delete qParams.geolocation
      delete qParams.context

      const carUrl =
        categoryUlr.replace(/map\/|map/, '') +
        qs.stringify(qParams, { arrayFormat: 'repeat', addQueryPrefix: true })

      return this.isPlot ? '/list' + carUrl : carUrl
    },
    mapLocationHandler() {
      return this.getFacetByName('location')
    }
  },
  watch: {
    handlersParamsValues() {
      this.scrollToTop()
    }
  },

  mounted() {
    const { csp } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    })
    const cspNumber = parseFloat(csp || this.csp)
    if (this.mobile && !isNaN(cspNumber)) {
      this.$nextTick(() => this.$emit('scroll-to-classified', cspNumber))
    } else if (cspNumber && this.$refs.resultsContainer) {
      this.$nextTick(() => {
        this.$refs.resultsContainer.scrollTo({ top: cspNumber })
      })
    }
  },
  methods: {
    ...mapMutations(CLASSIFIED_SEARCH_NS, {
      setPage: SET_PAGE
    }),
    ...mapActions(CLASSIFIED_SEARCH_NS, {
      search: 'search',
      viewTypeChanged: 'viewTypeChanged',
      searchForSellers: 'searchForSellers',
      toggleMobileFacets: 'toggleMobileFacets'
    }),

    onMouseEnter(classified: Classified | null) {
      if (
        !this.mobile &&
        classified &&
        this.hoverClassifiedId !== classified.id
      ) {
        const hoverClassified = {
          ...classified,
          price: classified.price ? classified.price.replace(' €', '') : null
        }
        this.$emit('classified-hover', hoverClassified)
        this.hoverClassified = hoverClassified
      }
    },
    handleThumbClick(payload) {
      const { classified, e, thumbData } = payload
      this.$emit('classified-click', {
        classified: toCamelCase(classified),
        e,
        thumbData
      })
    },
    showModal() {
      this.$refs.sortModal.showModal()
    },
    scrollToTop() {
      if (this.$refs.resultsContainer) {
        this.$refs.resultsContainer.scrollTo({ top: 0 })
      }
    },
    prefetchNextPage() {
      const paramsToPrepare = {
        ...this.rootParams,
        ...this.params,
        context: 'map-search',
        ...{
          pg: this.currentPage + 1
        }
      }
      const params = paramsValuesAsArrays(preprocessParams(paramsToPrepare))
      const searchService = this.$dep(SearchService)
      paramsToPrepare['per-page'] = [this.rowsPagination.perPage]
      if (this.showSellers) {
        return searchService.getSellers(params)
      }
      return searchService.getResults(params)
    },
    visibilityChanged(isVisible) {
      const { perPage, total } = this.rowsPagination
      if (
        isVisible &&
        this.currentPage * perPage < total &&
        !this.displayClusterRows
      ) {
        this.prefetchNextPage()
      }
    },
    handleFreezeClick() {
      this.$emit('freeze-list', !this.frozenList)
    },
    handlePageChange(pg: number) {
      if (this.displayClusterRows) {
        this.currentClusterPage = pg
      }
      this.$emit('page-change', pg)
    },
    freezeBtnVisibilityChange(visible: boolean) {
      this.freezeButtonShown = visible
    },
    handleResultsScroll(e) {
      if (!this.params.shop || this.mobile) {
        return
      }
      if (
        this.$refs.agentProfile?.$el &&
        e.target.scrollTop > this.$refs.agentProfile.$el.clientHeight / 2
      ) {
        this.isAgentProfileFullSize = false
      } else if (e.target.scrollTop < 2) {
        this.isAgentProfileFullSize = true
      }
    },
    setClusterPage(pg: number) {
      this.currentClusterPage = pg
    },
    handleVisibilityChange(visibility: boolean) {
      if (this.isExpandableMounted && !this.showSellers) {
        this.$emit('results-header-visibility-change', visibility)
      }
    }
  }
})
